import Vue from 'vue';
import Vuex from 'vuex';
import common from './common';
import getters from "./getter.js"
import permission from "./permission"
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    common,
    permission,
  },
  getters
});
